// extracted by mini-css-extract-plugin
export default {"btn":"ButtonDashedUI_btn__mcqMo"};